import { getCurrentFormattedUtcDate } from '@arc/unified-payments-frontend/date-utils';
import {
  StepChangeAnalyticsPayloadData,
  roundTo2Decimals,
  StepChangeAnalyticsPayload,
  CheckoutStep,
} from '@arc/unified-payments-frontend/shared-payment';
import { SessionStore } from '@arc/unified-payments-frontend/shared-stores';
import { createSelector } from '@ngrx/store';
import { selectAmount, selectTotalSurcharge } from './pay-on-account.selectors';
import { selectPaymentDetails } from '../reducers';
import { formatISO } from 'date-fns';

export const selectStepChangeAnalyticsPayloadData = createSelector(
  selectAmount,
  selectTotalSurcharge,
  selectPaymentDetails,
  SessionStore,
  (amount, surchargeFee, paymentDetails, session) => {
    const payload: StepChangeAnalyticsPayloadData = {
      total: roundTo2Decimals(amount + (surchargeFee ?? 0)),
      subtotal: amount,
      referenceNumber: paymentDetails.referenceNumber,
      referenceDate: paymentDetails.referenceDate
        ? formatISO(paymentDetails.referenceDate)
        : null,
      sessionId: session.sessionId,
      surchargeFee: surchargeFee ?? 0,
      timestamp: getCurrentFormattedUtcDate(),
    };
    return payload;
  },
);

export const paymentDetailsStepAnalyticsPayload = createSelector(
  selectStepChangeAnalyticsPayloadData,
  (payloadData) => {
    const payload: StepChangeAnalyticsPayload = {
      ...payloadData,
      step: CheckoutStep.PaymentDetails,
    };

    return payload;
  },
);

export const selectPaymentMethodStepAnalyticsPayload = createSelector(
  selectStepChangeAnalyticsPayloadData,
  (payloadData) => {
    const payload: StepChangeAnalyticsPayload = {
      ...payloadData,
      step: CheckoutStep.PaymentMethod,
    };

    return payload;
  },
);

export const reviewStepAnalyticsPayload = createSelector(
  selectStepChangeAnalyticsPayloadData,
  (payloadData) => {
    const payload: StepChangeAnalyticsPayload = {
      ...payloadData,
      step: CheckoutStep.Review,
    };

    return payload;
  },
);

export const selectConfirmationStepAnalyticsPayload = createSelector(
  selectStepChangeAnalyticsPayloadData,
  (payloadData) => {
    const payload: StepChangeAnalyticsPayload = {
      ...payloadData,
      step: CheckoutStep.Confirmation,
    };

    return payload;
  },
);
